import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1368eece"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unique-as-you-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "section" }, "APP"),
  /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "TAN ÚNICA COMO TÚ")
], -1))
const _hoisted_2 = { class: "unique-as-you-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "texts" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "MENÚ SEMANAL COMPLETO", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Planificación de todas las comidas de una semana para seguir durante un mes", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "CAMBIO INTELIGENTE DE RECETA", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Elige otras alternativas sin alterar ni una caloría tu arquitectura nutricional", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "REAJUSTES AUTOMÁTICOS", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Si tus entrenamientos cambian, tu nutrición se reajusta automáticamente.", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "CHAT CON TU NUTRICIONISTA", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Escribe a tu nutricionista cuando tengas dudas o necesites algún cambio puntual.", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "GRÁFICOS DE EVOLUCIÓN", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "La nutrición ya no es invisible. Comparte tu mejora con tus amigos y enemigos.", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "gp-apl-reviews" }
const _hoisted_21 = { class: "apple" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "250 valoraciones", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4,8", -1))
const _hoisted_25 = { class: "stars" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "google" }
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "95 valoraciones", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4,6", -1))
const _hoisted_35 = { class: "stars" }
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "appScreens",
    style: _normalizeStyle({
        backgroundImage:
        'url(' + require('@/assets/images/App.jpg') + ')'
    })
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "mobile-image",
        src: require('@/assets/images/'+ $data.mobile),
        alt: "embajadores",
        style: {"height":"561px","width":"301px"}
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass({first: $data.first}),
          onClick: _cache[0] || (_cache[0] = ($event: any) => {$data.first = !$data.first;
             $data.second = false; $data.third = false; $data.four = false; $data.five = false;
             $data.mobile = 'Plani.png'}),
          onKeydown: _cache[1] || (_cache[1] = ($event: any) => ($data.first = !$data.first))
        }, _hoisted_7, 34),
        _createElementVNode("div", {
          class: _normalizeClass({second: $data.second}),
          onClick: _cache[2] || (_cache[2] = ($event: any) => {$data.second= !$data.second;
             $data.first = false; $data.third = false; $data.four = false; $data.five = false;
             $data.mobile = 'Cambios-de-recetas.png'}),
          onKeydown: _cache[3] || (_cache[3] = ($event: any) => ($data.second = !$data.second))
        }, _hoisted_10, 34),
        _createElementVNode("div", {
          class: _normalizeClass({third: $data.third}),
          onClick: _cache[4] || (_cache[4] = ($event: any) => {$data.third= !$data.third;
             $data.first = false; $data.second = false; $data.four = false; $data.five = false;
             $data.mobile = 'Entrenamientos.png'}),
          onKeydown: _cache[5] || (_cache[5] = ($event: any) => ($data.second = !$data.second))
        }, _hoisted_13, 34),
        _createElementVNode("div", {
          class: _normalizeClass({four: $data.four}),
          onClick: _cache[6] || (_cache[6] = ($event: any) => {$data.four= !$data.four;
             $data.first = false; $data.second = false; $data.third = false; $data.five = false;
             $data.mobile = 'Chat.png'}),
          onKeydown: _cache[7] || (_cache[7] = ($event: any) => ($data.four = !$data.four))
        }, _hoisted_16, 34),
        _createElementVNode("div", {
          class: _normalizeClass({five: $data.five}),
          onClick: _cache[8] || (_cache[8] = ($event: any) => {$data.five= !$data.five;
             $data.first = false; $data.second = false; $data.third = false; $data.four = false;
             $data.mobile = 'Graficos.png'}),
          onKeydown: _cache[9] || (_cache[9] = ($event: any) => ($data.five = !$data.five))
        }, _hoisted_19, 34)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("img", {
            src: require('@/assets/images/apple.svg'),
            alt: "android_icon"
          }, null, 8, _hoisted_22),
          _hoisted_23,
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("img", {
              src: require('@/assets/images/fav_star.png'),
              alt: "fav_star"
            }, null, 8, _hoisted_26),
            _createElementVNode("img", {
              src: require('@/assets/images/fav_star.png'),
              alt: "fav_star"
            }, null, 8, _hoisted_27),
            _createElementVNode("img", {
              src: require('@/assets/images/fav_star.png'),
              alt: "fav_star"
            }, null, 8, _hoisted_28),
            _createElementVNode("img", {
              src: require('@/assets/images/fav_star.png'),
              alt: "fav_star"
            }, null, 8, _hoisted_29),
            _createElementVNode("img", {
              src: require('@/assets/images/fav_half_star.png'),
              alt: "fav_half_star"
            }, null, 8, _hoisted_30)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("img", {
            src: require('@/assets/images/android.png'),
            alt: "apple-icon"
          }, null, 8, _hoisted_32),
          _hoisted_33,
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("img", {
              src: require('@/assets/images/fav_star.png'),
              alt: "fav_star"
            }, null, 8, _hoisted_36),
            _createElementVNode("img", {
              src: require('@/assets/images/fav_star.png'),
              alt: "fav_star"
            }, null, 8, _hoisted_37),
            _createElementVNode("img", {
              src: require('@/assets/images/fav_star.png'),
              alt: "fav_star"
            }, null, 8, _hoisted_38),
            _createElementVNode("img", {
              src: require('@/assets/images/fav_star.png'),
              alt: "fav_star"
            }, null, 8, _hoisted_39),
            _createElementVNode("img", {
              src: require('@/assets/images/fav_half_star.png'),
              alt: "fav_half_star"
            }, null, 8, _hoisted_40)
          ])
        ])
      ])
    ])
  ], 4))
}